import React from "react";
import Quote from '../components/Quote';
import BottomPipe from '../components/BottomPipe';
import cynthia from '../assets/photos/headshots/m-headshot-cynthia.png';

export default ({ isActive }) => {
  const message = 'Trials really matter. I’m getting a high standard of care in a trial whether I get the experimental therapy or the standard treatment. Also they move the science forward, which moves care forward, which translates into better patient care, longer healthier lives with better quality of life.';
  const quote = {
    author: 'Cynthia Chauhan',
    position: 'Clinical trial participant and patient advocate in the United States',
    img: cynthia,
    quote: [message]
  }
  return (
    <div className="component hide-overflow">
      <Quote isActive={isActive} quote={quote} position={'top'} />
      <BottomPipe isActive={isActive} />
    </div>
  );
};